// Shared configuration for VISION site
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Optimized, transcoded background media (served from backend with byte-range).
// Original 34-36MB portrait MP4s → ~1-6MB MP4/WebM with progressive playback.
export const MEDIA = {
  heroVideoMp4:  `${BACKEND_URL}/api/media/hero.mp4`,
  heroVideoWebm: `${BACKEND_URL}/api/media/hero.webm`,
  heroPoster:    `${BACKEND_URL}/api/media/hero-poster.jpg`,
  aboutVideoMp4:  `${BACKEND_URL}/api/media/about.mp4`,
  aboutVideoWebm: `${BACKEND_URL}/api/media/about.webm`,
  aboutPoster:    `${BACKEND_URL}/api/media/about-poster.jpg`,
};

// Official Payhip storefront
export const PAYHIP_STORE_URL = "https://payhip.com/JUniverse";

export const BRAND = {
  name: "VISION",
  tagline: "Live With Vision.",
  instagramHandle: "@wrldofvsn",
  instagramUrl: "https://instagram.com/wrldofvsn",
  email: "coachjohnsonrecruiting9@gmail.com",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_vision-lifestyle-1/artifacts/5lqazn9v_SpeedFactory%20%285%29.png",
};

// Only authentic brand photography — verified content mapping.
export const ASSETS = {
  logo: BRAND.logoUrl,

  // Original set — content verified
  golf:
    "https://customer-assets.emergentagent.com/job_0e4102a7-6550-49c4-a709-44bf276846f6/artifacts/5wmqi1wv_62.png",
  climbing:
    "https://customer-assets.emergentagent.com/job_0e4102a7-6550-49c4-a709-44bf276846f6/artifacts/4g0jaby6_63.png",
  joshuaTree:
    "https://customer-assets.emergentagent.com/job_0e4102a7-6550-49c4-a709-44bf276846f6/artifacts/b7ppdqct_64.png",
  amalfi:
    "https://customer-assets.emergentagent.com/job_0e4102a7-6550-49c4-a709-44bf276846f6/artifacts/3hz1ksl0_69.png",

  // Second batch — content verified
  pierMorning:
    "https://customer-assets.emergentagent.com/job_vision-lifestyle-1/artifacts/xti1v6br_IMG_5679.jpeg",
  sunriseVista:
    "https://customer-assets.emergentagent.com/job_vision-lifestyle-1/artifacts/78tvt3l8_IMG_5682.jpeg",
  columnsPortrait:
    "https://customer-assets.emergentagent.com/job_vision-lifestyle-1/artifacts/ag1igv3y_IMG_5683.jpeg",
  sunsetOcean:
    "https://customer-assets.emergentagent.com/job_vision-lifestyle-1/artifacts/aoly1r0f_IMG_5684.jpeg",
  skyClouds:
    "https://customer-assets.emergentagent.com/job_vision-lifestyle-1/artifacts/h11eep36_IMG_5687.jpeg",

  // Third batch — content verified
  basketball:
    "https://customer-assets.emergentagent.com/job_vision-lifestyle-1/artifacts/z3geb5xj_65.png",
  blueHallway:
    "https://customer-assets.emergentagent.com/job_vision-lifestyle-1/artifacts/a5zhkrvj_66.png",
  football:
    "https://customer-assets.emergentagent.com/job_vision-lifestyle-1/artifacts/7u9g08ly_68.png",
  pagoda:
    "https://customer-assets.emergentagent.com/job_vision-lifestyle-1/artifacts/1pm2ffu8_IMG_5678.jpeg",
  capri:
    "https://customer-assets.emergentagent.com/job_vision-lifestyle-1/artifacts/lbu8u5mx_IMG_8802_Original.jpeg",
};

// Live Payhip catalog — real products, real product-page URLs, real Payhip CDN imagery.
export const PAYHIP_PRODUCTS = [
  {
    slug: "feather-vision-sweatshorts",
    name: "Feather Vision Sweatshorts",
    tag: "Shorts",
    price: "From $40",
    description: "Featherweight, built for motion and the long walk home.",
    url: "https://payhip.com/b/O3MWp",
    img: "https://payhip.com/cdn-cgi/image/format=auto,width=750/https://pe56d.s3.amazonaws.com/o_1jmqcvqs1nur14ie1tkb30e12ush.jpeg",
    in_stock: true,
  },
  {
    slug: "sky-vision-sculpt-leggings",
    name: "Sky Vision Sculpt Leggings",
    tag: "Women's",
    price: "From $45",
    description: "Second-skin sculpt, engineered to move with intention.",
    url: "https://payhip.com/b/lDQ8k",
    img: "https://payhip.com/cdn-cgi/image/format=auto,width=750/https://pe56d.s3.amazonaws.com/o_1jmqkp7i61rhrjsgeuc1cdv1o90h.jpeg",
    in_stock: true,
  },
  {
    slug: "vision-sculpt-tee-sky-blue",
    name: "Vision Sculpt Tee — Sky",
    tag: "Women's",
    price: "From $28",
    description: "Softly sculpted cotton, cut for the everyday practice.",
    url: "https://payhip.com/b/J1rnN",
    img: "https://payhip.com/cdn-cgi/image/format=auto,width=750/https://pe56d.s3.amazonaws.com/o_1jmqg4mhf18vfhcf17sah6695gh.jpeg",
    in_stock: true,
  },
  {
    slug: "globe-athletic-shorts",
    name: "Globe Athletic Shorts",
    tag: "Shorts",
    price: "From $45",
    description: "Every mile carries the emblem — anywhere on the map.",
    url: "https://payhip.com/b/V4iSn",
    img: "https://payhip.com/cdn-cgi/image/format=auto,width=750/https://pe56d.s3.amazonaws.com/o_1jmqfsm781d291chm626mcf6v1h.png",
    in_stock: false,
  },
  {
    slug: "night-vision-sweatshorts",
    name: "Night Vision Sweatshorts",
    tag: "Shorts",
    price: "From $40",
    description: "Matte black, quietly considered — for the hour before rest.",
    url: "https://payhip.com/b/8QhTH",
    img: "https://payhip.com/cdn-cgi/image/format=auto,width=750/https://pe56d.s3.amazonaws.com/o_1jmqc452t181p12s07e41eq61reck.jpeg",
    in_stock: false,
  },
  {
    slug: "vision-sculpt-tee-forest-green",
    name: "Vision Sculpt Tee — Forest",
    tag: "Women's",
    price: "From $28",
    description: "Earth-tone essentials, made to be lived in.",
    url: "https://payhip.com/b/N9t14",
    img: "https://payhip.com/cdn-cgi/image/format=auto,width=750/https://pe56d.s3.amazonaws.com/o_1jmql7i3s1jli10c110jids710nqh.png",
    in_stock: false,
  },
];
